// extracted by mini-css-extract-plugin
module.exports = {"container":"MiniPlayerHeader_container__34iy6","draggableTitleStyle":"MiniPlayerHeader_draggableTitleStyle__25Ukh","goBackButton":"MiniPlayerHeader_goBackButton__2D_4-"};